import React from 'react';
import { useConnect } from '@lore/query-connect';
import NoteTemplate from '../../feed/NoteTemplate';
import useDialogLauncher from '../../../../hooks/@lore/dialogs-routable/_hooks/useDialogLauncher';
import { DialogManager } from '../../../dialogs_new/DialogManager';

export default function EventNote(props) {
  const { note } = props;

  const event = useConnect('event.byId', {
    id: note.data.eventId
  });

  const activity = useConnect('tag.byId', {
    id: event.data.activityId
  }, {
    enabled: !!event.data.activityId
  });

  const launch = useDialogLauncher();

  function onClick() {
    launch(DialogManager.EventManage.Config(event.id));
  }

  return (
    <NoteTemplate
      note={note}
      title={`${event.data.title || activity.data.name}`}
      type="event"
      last={props.last}
      onClick={onClick}
    />
  );
}
